$ = require 'jquery'
Elements = require './elements'
{ forEach, delay } = require 'lodash'

module.exports =
class Deblurring

  selector: '.js-deblurring'

  constructor: (@$el) ->

  redraw: ->
    forEach @$el.find(@selector), (el) =>
      $el = $ el
      txt = $el.html()
      $el
        .before "<span class='deblurring-copy'>#{txt}</span>"
        .css
          display  : 'block'
          opacity  : .01
          transform: 'skew(0deg, 10deg)'
      $copy = $el.prev '.deblurring-copy'
        .css
          display : 'block'
          width   : $el.width()
          position: 'absolute'
      delay =>
        $el
          .css
            transform: 'skew(0deg, 0deg)'
          .velocity
            opacity: 1
          ,
            duration: 200
        $copy
          .velocity
            opacity: 0
          ,
            duration: 200
            complete: =>
              $copy.remove()
      , 0



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/deblurring.coffee